<div id="page">
  <span class="screen-darken"></span>
  <app-market-prices-ticker></app-market-prices-ticker>
  <app-topbar></app-topbar>
  <app-header-new></app-header-new>
  <router-outlet></router-outlet>
  <app-footer *ngIf="apiService.show_header_footer"></app-footer>
  <app-back-to-top></app-back-to-top>
  <app-whatsapp-chat></app-whatsapp-chat>
</div>
